import VueCookies from "vue-cookies";
import {CODE_RESPONSE, COOKIES} from "@/constants";
import i18n from "@/langs/i18n";

export function handleError(error: any): any {
  const {status, data} = error.response;

  if (status === 404) return window.location.href = '/error/404'

  if (data['code'] == CODE_RESPONSE.IS_NOT_COMPLETED_TUTORIAL) {
    const babyId = data['data']['babyId'];
    return window.location.href = `/baby/${babyId}/tutorial/start`
  }

  if (data['code'] == CODE_RESPONSE.IS_COMPLETED_TUTORIAL) {
    return window.location.href = `/tutorial/finish`
  }

  if ((status === 401 && !data['code']) || status === 403) {
    (VueCookies as any).remove(COOKIES.accessToken)
    return window.location.href = '/auth/login'
  }
  return {
    hasError: true,
    message: i18n.tc(data.message).toString(),
    errors: data.errors ? data.errors.map((error: string) => i18n.tc(error).toString()) : []
  }
}
